import { useCallback, useState } from 'react'

export function useToggleBoolean(initialState: boolean = false) {
  const [bool, setBool] = useState(initialState)
  const toggleBool = useCallback(() => setBool((b) => !b), [])
  const setOpen = useCallback((value: boolean) => setBool(value), [])

  return [bool, toggleBool, setOpen] as const
}
